import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbProps } from 'components/Breadcrumb';

type BreadcrumbsProps = {
  breadcrumbRoutes: BreadcrumbProps['routes'];
  separator?: React.ReactNode;
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  breadcrumbRoutes,
  separator,
}) => (
  <Breadcrumb data-cy="breadcrumbs" separator={separator}>
    {breadcrumbRoutes.map(({ breadcrumbName, path }) => (
      <Breadcrumb.Item key={breadcrumbName} data-cy={`breadcrumb-${path}`}>
        <Link to={path}>{breadcrumbName}</Link>
      </Breadcrumb.Item>
    ))}
  </Breadcrumb>
);

export default Breadcrumbs;
